/* Oricle accessory buy panel: the purchase-type choice drives the one hidden `selling_plan` field
   (posted only when the plan row is chosen), and a variant tile, when a product has options, sets
   the variant id and the shown price. Quantity comes from the visible stepper (oricle-pdp.js).
   Without JavaScript the form posts one unit, one-time. */
(() => {
  const money = (cents, format) => {
    const n = (Math.round(cents) / 100).toFixed(2).replace(/\.00$/, '');
    const withCommas = n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, withCommas);
  };
  class OricleAccForm extends HTMLElement {
    connectedCallback() {
      if (this._bound) return; this._bound = true;
      this.idInput = this.querySelector('[data-o-variant-id]');
      this.planInput = this.querySelector('[data-o-plan-input]');
      this.once = this.querySelector('[data-o-ptype-once]');
      this.sub = this.querySelector('[data-o-ptype-sub]');
      this.format = this.dataset.moneyFormat || '${{amount}}';
      this.addEventListener('change', (e) => {
        if (e.target.closest('[data-o-ptype-once],[data-o-ptype-sub]')) this.syncPlan();
        else if (e.target.closest('[data-o-vtile-input]')) this.syncVariant(e.target);
      });
      this.syncPlan();
    }
    syncPlan() {
      const subscribe = !!(this.sub && this.sub.checked);
      [this.once, this.sub].forEach((r) => { const t = r && r.closest('[data-o-ptype-tile]'); if (t) t.classList.toggle('is-on', r.checked); });
      if (this.planInput) {
        this.planInput.disabled = !subscribe;
        this.planInput.value = subscribe && this.sub ? (this.sub.dataset.plan || '') : '';
      }
    }
    syncVariant(input) {
      this.querySelectorAll('[data-o-vtile]').forEach((t) => t.classList.toggle('is-on', t.contains(input)));
      if (this.idInput && input.value) this.idInput.value = input.value;
      const price = parseInt(input.dataset.price, 10);
      if (price) this.querySelectorAll('[data-o-price]').forEach((el) => { el.textContent = money(price, this.format); });
      const add = this.querySelector('[data-o-add]');
      if (add) {
        const soldOut = input.dataset.available === 'false';
        add.disabled = soldOut;
        const label = add.querySelector('[data-o-cta-label]');
        if (label) label.textContent = soldOut ? 'Sold out' : label.dataset.label;
      }
    }
  }
  if (!customElements.get('oricle-acc-form')) customElements.define('oricle-acc-form', OricleAccForm);
})();
